<template>
    <div class="report-title-bar my-report-title-bar dsp-flex">
        <div class="report-title-side">
            <span v-if="fromEmbedded" class="report-title-back" @click="beforeEmbeddedBackCheck">
                <i class="iconfont icon-guanbi"></i>
            </span>
            <span v-else class="report-title-back" @click="beforeBackCheck">
                <i class="iconfont icon-xiangzuo"></i>
            </span>
        </div>
        <div class="report-title-mid">
            <span>{{detailInfo.f_name+(reportData && reportData.ymd ? '('+reportData.ymd.split(' ')[0]+')' : '')}}</span>
        </div>
        <div class="report-title-side" @click="clickYear">
            <div class="report-title-icon" :style="settingConfigData.year_bz ? 'background-image: url('+settingConfigData.year_bz+')' : ''"></div>
        </div>
    </div>
</template>

<script>
import { MIX, SCHEME } from '../../modules/utils'
export default {
    name: 'ReportTitleBar',
    computed: {
        fromEmbedded() {
            return this.$store.state.embedded.fromEmbedded;
        },
        detailInfo() {
            return this.$store.state.report.detailInfo;
        },
        reportData() {
            return this.$store.state.report.reportData;
        },
        settingConfigData() {
            return this.$store.state.setting.settingConfigData;
        },
    },
    data() {
        return {
            hideName: false
        }
    },
    methods: {
        beforeEmbeddedBackCheck() {
            // 嵌入页面点击X关闭
            SCHEME.closeWebView();
            this.$store.dispatch('report/resetReportData');
        },
        beforeBackCheck() {
            if(this.$store.state.report.setReportAILeaveDone) {
                // addOtherShow上报1
                MIX.trackPageViewed('ForeverVipNewUserPage', 'new_user');
                this.$store.dispatch('report/updateReportAddOtherShow', { 
                    params: {type: 1},
                    sucCb: ()=> {
                        this.clickBack();
                    }
                });
                return;
            }
            this.$store.state.report.curReportActPopupData = null; //清空数据
            let detailInfo = this.$store.state.detail.personInfo;
            this.$store.dispatch('report/setReportAILeave', {
                params: {hid: detailInfo.id},
                failCb: () => {
                    // addOtherShow上报1
                    MIX.trackPageViewed('ForeverVipNewUserPage', 'new_user');
                    this.$store.dispatch('report/updateReportAddOtherShow', { 
                        params: {type: 1},
                        sucCb: ()=> {
                            this.clickBack();
                        }
                    });
                }
            });
        },
        clickBack() {
            this.$store.dispatch('report/resetReportData');
            var curParams = this.$router.history.current.params;
            console.log('ReportTitleBar---clickBack------', curParams)
            // 处理页面跳转
            if(curParams.from && curParams.from != '') {
                if(curParams.from == 'share') {
                    this.$router.back();                    
                }else if(curParams.from == 'discusslist') {
                    let detailInfo = this.$store.state.detail.personInfo;
                    if(detailInfo && detailInfo.id) {
                        this.$router.replace('/discuss/discusslist/'+detailInfo.id);
                    }
                }else if(curParams.from == 'discussmain') {
                    let lunpanData = this.$store.state.discuss.lunpanData;
                    if(lunpanData && lunpanData.id) {
                        this.$router.replace('/discuss/discussmain/'+lunpanData.id);
                    }
                }else if(curParams.from.indexOf('discussshare') >= 0) {
                    let tempArr = curParams.from.split('-'),
                        fromPage = tempArr[1], shareCode = tempArr[2];
                    console.log('discussshare----', fromPage, shareCode);
                    this.$router.replace('/share/discuss/'+fromPage+'/'+shareCode);
                }else if(curParams.from == 'collate') {
                    this.$router.replace('/collate');
                }else {
                    this.$router.replace('/detail/'+curParams.from+'/'+curParams.id);
                }
            }
        },
        clickYear() {
            var detailInfo = this.detailInfo,
                curParams = this.$router.history.current.params;;
            console.log('ReportTitleBar---clickBack------', curParams)
            this.$store.dispatch('year/initYearCharacter', {
                detailInfo: detailInfo,
                characterCb: ()=> {
                    if(curParams && curParams.from && curParams.from != '') {
                        this.$router.replace('/yearcharacter/'+curParams.from+'/'+curParams.id);
                    }
                },
                reportCb: ()=> {
                    this.$store.dispatch('year/getYearReportInfo', {
                        cb: ()=> {
                            this.$store.dispatch('report/resetReportData');
                            if(curParams && curParams.from && curParams.from != '') {
                                this.$router.replace('/year/'+curParams.from+'/'+curParams.id);
                            }
                        }
                    });
                }
            })

        }
    }
}
</script>